<!-- //
知识库管理
@auth xuyd
@date 2024-05-05
//-->
<template>
  <page-layout layout="A|C">
    <div slot="pageAside" style="width: 220px;height: 100%;">
      <div class="flex-row" style="padding-bottom: 5px;">
        <el-input size="small" v-model="searchVal" placeholder="搜索标题">
          <el-button slot="append" @click="handleAddGroup">添加</el-button>
        </el-input>
      </div>
      <el-scrollbar class="scroll-container">
        <el-tree
            :data="groupList"
            :props="defaultProps"
            :show-checkbox="false"
            :expand-on-click-node="false"
            node-key="id"
            :current-node-key="currentNodeKey"
            :filter-node-method="filterNode"
            ref="refTree"
            default-expand-all
            highlight-current
            @node-click="handleNodeClick"
        >
          <div class="custom-tree-node" slot-scope="{data, node}">
            <div class="content">
              <i v-if="data.docType === 1" class="el-icon-document"></i>
              <i v-else class="el-icon-folder"></i>
              <span class="ml5">{{ node.label }} </span>
            </div>
            <div class="opts">
              <el-button size="small"
                         type="text"
                         v-if="data.docType !== 1"
                         icon="el-icon-plus"
                         style="margin-right: 10px;"
                         @click.stop="handleAdd(data)"/>
            </div>
          </div>
        </el-tree>
      </el-scrollbar>
    </div>
    <!-- 结果区域 -->
    <div class="layout-result result-height">
      <div v-if="visibleDoc" style="padding: 0;margin: 0; height: auto">
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button size="small" v-if="!editMode" type="primary" plain @click="handleEdit">编辑</el-button>
            <el-button size="small" v-if="!editMode" type="primary" plain @click="handleDelete">删除</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button size="small" v-if="editMode" type="primary" plain @click="handleSave">保存</el-button>
            <el-button size="small" v-if="editMode" type="primary" plain @click="handlePreview">预览</el-button>
            <el-button size="small" v-if="editMode && !!this.form.id" type="primary" plain  @click="handleCancel">取消
            </el-button>
          </el-col>
        </el-row>
        <el-form @submit.native.prevent v-if="editMode" ref="refForm" :model="form" size="small" label-width="0"
                 class="form-container flex-column">
          <el-form-item prop="title" label="">
            <el-input v-model="form.title"
                      size="small"
                      maxlength="100"
                      style="width: 100%;font-size:18px;color: #333333!important;"
                      placeholder="标题"
                      clearable/>
          </el-form-item>
          <el-form-item prop="docContent" label="" class="full-item">
            <wang-editor v-model="form.docContent"/>
          </el-form-item>
        </el-form>
        <div v-else class="doc-layout">
          <div class="title" style="text-align: center">{{ form.title }}</div>
          <div class="tip mt20" style="text-align: left">
            <span>创建人：{{ form.createUser }}</span>
            <span class="ml10">创建时间：{{ form.createTime }}</span>
            <span class="ml10"> 最后修改人：{{ form.updateUser }}</span>
            <span class="ml10"> 最后修改时间：{{ form.updateTime }}</span>
          </div>
          <div v-html="form.docContent"></div>
        </div>
      </div>
    </div>
    <group-add ref="refGroupAdd"/>
    <DocPreviewDlg ref="refDocPreviewDlg"/>
  </page-layout>
</template>
<script>

import WikiApi from '@/api/wiki/wiki.api.js'
import GroupAdd from './group-add'
import WangEditor from "@/components/Editor/wangEditor";
import DocPreviewDlg from './doc-preview-dlg';

export default {
  name: 'ViewDocWiki',
  components: {GroupAdd, WangEditor, DocPreviewDlg},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
  ],
  data() {
    return {
      editMode: false,
      searchVal: null,
      currentNodeKey: null, // 选择的doc
      visibleDoc: false, // 显示右侧内容
      groupList: [],
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      form: {
        id: null, // 内容Id
        parentId: null,
        title: null,
        docContent: null,
        docType: null,
        status: null,
        createUser: null,
        createTime: null,
        updateUser: null,
        updateTime: null,
      },
      rules: {
        title: [{required: true, message: "请输入标题", trigger: 'blur'}],
      },
    };
  },
  watch: {
    searchVal(val) {
      this.$refs.refTree.filter(val)
    }
  },
  created() {
    this.getList();
  },
  methods: {
    initForm() {
      this.form = {
        id: null,
        parentId: null,
        title: '',
        docContent: '',
        createUser: null,
        createTime: null,
        updateUser: null,
        updateTime: null
      }
    },
    getList() {
      WikiApi.selectWikiGroupList().then((resp) => {
        this.groupList = this.$util.listToTree(resp.data, {idField: 'id', pidField: 'parentId'});
        this.$nextTick(() => {
          this.$refs.refTree.setCurrentKey(this.currentNodeKey);
        });
      });
    },

    handleQuery() {
      WikiApi.getDocWiki(this.currentNodeKey).then(resp => {
        if (!resp.data.docContent) {
          resp.data.docContent = '';
        }
        this.form = resp.data;
      })
    },

    filterNode(value, data) {
      if (!value) return true;
      return data['title'].indexOf(value) !== -1;
    },

    handleAdd(data) {
      // console.log("----handleAdd---->", JSON.stringify(data))
      this.visibleDoc = true;
      this.editMode = true;
      this.initForm();
      this.form.parentId = data.id;
    },

    /**
     * 点击节点
     *
     * @param data
     */
    handleNodeClick(data) {
      console.log("----handleNodeClick---->", data)
      if (data.docType !== 1) {
        return;
      }
      this.editMode = false;
      this.currentNodeKey = data.id;
      this.visibleDoc = true;
      this.handleQuery();
    },

    /**
     * 同步group
     */
    handleAddGroup() {
      this.$refs.refGroupAdd.showModal({
        data: {},
        onOk: (data) => {
          this.getList();
        }
      })
    },

    /** 编辑 */
    handleEdit() {
      this.editMode = true;
    },

    /** 删除 */
    handleDelete() {
      this.$modal.confirm(`确定要删除【${this.form.title}】内容吗？`).then(() => {
        WikiApi.deleteDocWiki(this.form.id).then((resp) => {
          this.$modal.msgSuccess("删除成功");
          this.getList();
        });
      })
    },

    /** 预览 */
    handlePreview() {
      this.$refs.refDocPreviewDlg.showModal({
        data: {...this.form},
      })
    },

    /** 取消 */
    handleCancel() {
      if (!this.form.id) return;
      this.editMode = false;
      WikiApi.getDocWiki(this.form.id).then(resp => {
        if (!resp.data.docContent) {
          resp.data.docContent = '';
        }
        this.form = resp.data;
      })
    },

    /** 保存 */
    async handleSave() {
      let {id, title, docContent} = this.form;
      let params = {id, title, docContent, docType: 1, parentId: this.form.parentId};
      console.log("======>", this.form);
      this.$refs.refForm.validate(valid => {
        if (valid) {
          this.saveLoading = true;
          WikiApi.saveDocWiki(params).then(resp => {
            this.$modal.msgSuccess("保存成功");
            this.saveLoading = false;
            this.editMode = false;
            this.currentNodeKey = resp.data;
            this.getList();
            this.handleQuery();
          }).catch(() => {
            this.saveLoading = false;
          });
        }
      })
    },

  }
}
</script>

<style lang="less" scoped>
.scroll-container {
  height: calc(100% - 37px);
  box-sizing: border-box;

  .el-scrollbar__wrap {
    overflow-x: hidden;
    overflow-y: scroll;
  }

  :deep(.el-tree-node) {
  }

  :deep(.el-tree-node):hover .opts {
    display: inline-block;
  }

  :deep(.el-tree-node__content) {
    height: 36px;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .content {
      display: flex;
      align-items: center;
    }
  }
}

.doc-layout {
  display: flex;
  flex-direction: column;

  .title {
    font-size: 20px;
  }

  .tip {
    font-size: 12px;
    color: #aaaaaa;
  }
}

.result-height {
  height: 100%;
  overflow: auto;
}
</style>
